import lang from '@/lang'
import { UNSAFE_openModal as openModal } from '@/modules/_helpers/openModal'

export const openNotesAlert = (notes, modalTitle = '') => {
  openModal(close => ({
    component: 'ConfirmModal',
    props: {
      title: modalTitle || lang.transactionEdit.recipient.notesOnCustomerOrSupplier,
      description: notes,
      noCancel: true,
      descriptionAsHtml: true,
      onConfirm: () => {
        close()
      },
    },
  }))
}
